import { useApp } from '../app-context';
import { BanneredMenu } from '../components/BanneredMenu';
import { ClaimsList } from '../components/ClaimsList';
import { TSPage, TSAccordion } from '../components/commons';
import './PolicyPage.scss';
import { Utils } from '../Utils';
import { DashService } from '../services/DashService';

const PolicyPage = function ({ name, pageState, policy }) {
    const [state, dispatcher] = useApp();

    let pendingClaims = [];
    let openClaims = [];
    let closedClaims = [];

    (state.profile?.pendingClaims || []).forEach(v => {
        if (policy?.id === v.pet.id)
            pendingClaims.push(v);
    });
    (state.profile?.openClaims || []).forEach(v => {
        if (policy?.id === v.pet.id)
            openClaims.push(v);
    });
    (state.profile?.closeClaims || []).forEach(v => {
        if (policy?.id === v.pet.id)
            closedClaims.push(v);
    });

    const handleOpenClaim = async (e) => {
        try {
            let data = await DashService.openClaim(state._token, policy?.policyId);
            dispatcher({ action: 'showPage', params: {id: 'botClaim', props: {botScript: data.claimScript, botToken: data.claimSession}}});
        } catch(ex) {
            Utils.displaySimpleMsg(dispatcher, ex?.message || "שגיאה לא ידועה");
        }
    };

    const handleBankPayment = (e) => {
        handleCloseMsg();
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                Utils.displaySimpleMsg(dispatcher,
                    <div onClick={(e) => {
                        e.stopPropagation();
                    }}>
                        <p>
                            לתשלום בהוראת קבע בנקאית ניתן להקים הרשאה באתר הבנק בציון קוד מוסד 7394 ושליחת אסמכתא ואישור לניהול חשבון למייל
                            &nbsp;<a href='mailto:office@chayuta.com'>office@chayuta.com</a>&nbsp;
                            תוך ציון שם מלא ומספר תעודת זהות.
                        </p>
                        <br />
                        <p>
                            או לחילופין
                            &nbsp;
                            <a target="_blank"
                                href='https://assets.chayuta.com/shomera/payment-order.pdf'>
                                להורדת הטופס</a>
                            &nbsp;
                            למילוי וחתימה ע"י הבנק.
                        </p>
                    </div>);
            });
        });
    };

    const handleCreditPayment = (e) => {
        handleCloseMsg();
        dispatcher({ action: "showPage", params: { id: "payment", props: { policyId: policy.id, endDate: policy.endDate, policyType: policy.policyType } } });
    };

    const handleCloseMsg = (e) => {
        dispatcher({ action: "closePage", params: { id: "msg" } });
    };

    const handleChangePayment = (e) => {
        dispatcher({
            action: "showPage", params: {
                id: "msg",
                props: {
                    children: [
                        <div onClick={(e) => {
                            e.stopPropagation();
                        }}>
                            <div key="txt">
                                איזה אמצעי תשלום ברצונך לעדכן?
                            </div>
                            <div key="btns" className="dialog-buttons">
                                <button key="btn1" className="shorter" onClick={handleCreditPayment}>כרטיס אשראי</button>
                                {policy.policyType === 1 ? undefined : <button key="btn2" className="shorter" onClick={handleBankPayment}>הוראת קבע</button>}
                            </div>
                        </div>
                    ]
                }
            }
        });
    };

    let firstStartDate = Utils.formatLocalDate(Utils.dateStringToObj(policy?.firstStartDate));
    let startDate = Utils.formatLocalDate(Utils.dateStringToObj(policy?.startDate));
    let endDate = Utils.formatLocalDate(Utils.dateStringToObj(policy?.endDate));

    let txt = "";

    switch (policy.status * 1) {
        case 10:
            txt = "פעילה";
            break;
        case 20:
            txt = "הסתיימה";
            break;
        case 25:
            txt = "בוטלה";
            break;
        default:
    }

    return (
        < TSPage name={name} pageState={pageState} className="fading" >
            <div className="ts-limiter">
                <BanneredMenu policy={policy}></BanneredMenu>
                <div className="mainContent">
                    <div className="top">
                        <button className="yellow menu-item" onClick={handleOpenClaim}>הגשת תביעה אונליין</button>
                        <a href="tel:*6558" className="dial-link tel menu-item"><img src="/img/tel-dark.svg" alt="tel" />*6558</a>
                        <h3 className="main-title">{"הפוליסה של " + policy.name}</h3>
                    </div>
                    <div className="card white">
                        <TSAccordion title="תביעות" uiParams={state.uiParams}>
                            <div className="">
                                {!openClaims.length && !closedClaims.length && !pendingClaims.length ?
                                    <div className="exp">לא קימות תביעות</div>
                                    :
                                    undefined
                                }

                                {openClaims.length ?
                                    <ClaimsList claims={[...pendingClaims, ...openClaims]} title="תביעות בתהליך" />
                                    :
                                    undefined
                                }

                                {closedClaims.length ?
                                    <ClaimsList claims={closedClaims} title="תביעות שטופלו" />
                                    :
                                    undefined
                                }
                            </div>
                        </TSAccordion>
                    </div>
                    <div className="card white coverage">
                        <TSAccordion title="נתוני הפוליסה" forceToggle={true} uiParams={state.uiParams}>
                            <div className="payment-button"><button className="blue menu-item" onClick={handleChangePayment}>עדכון אמצעי תשלום</button> </div>

                            <table className="detailsTable">
                                <tbody>
                                    <tr>
                                        <td>מסלול</td>
                                        <td>{policy?.product}</td>
                                    </tr>
                                    {firstStartDate == startDate ? undefined :
                                        <tr>
                                            <td>תאריך הצטרפות לביטוח</td>
                                            <td>{firstStartDate}</td>
                                        </tr>
                                    }
                                    <tr>
                                        <td>תאריך תחילה</td>
                                        <td>{startDate}</td>
                                    </tr>
                                    <tr>
                                        <td>תאריך סיום</td>
                                        <td>{endDate}</td>
                                    </tr>
                                    <tr>
                                        <td>השתתפות עצמית</td>
                                        <td>{policy?.deductibleAndExcess}</td>
                                    </tr>
                                    <tr>
                                        <td>מספר פוליסה</td>
                                        <td>{policy?.policyId + policy?.policySuffix || ""}</td>
                                    </tr>
                                    <tr>
                                        <td>מהדורה</td>
                                        <td>{policy?.policyRevision || ""}</td>
                                    </tr>
                                    <tr>
                                        <td>גבול אחריות שנתי</td>
                                        <td>{policy?.annualLimit || " 15,000 ש\"ח"}</td>
                                    </tr>
                                    <tr>
                                        <div className={`policy-status-label state${policy?.status * 1}`}><img src="/img/claim-icon-finished.svg" alt="" /><span>{txt}</span></div>
                                    </tr>
                                    <tr />
                                    <tr />
                                </tbody>
                            </table>

                            <table className="detailsTable">
                                <tbody>
                                    <tr><td className='petName'>{policy?.name || ""}</td><td></td></tr>
                                    <tr><td>גיל</td><td>{policy?.age || ""}</td></tr>
                                    <tr><td>גזע</td><td>{policy?.breed || ""}</td></tr>
                                </tbody>
                            </table>

                        </TSAccordion>
                    </div>
                </div>
            </div>
        </TSPage >
    );
}

export { PolicyPage };